<template>
    <Dialog :visible="visible" class="dialog-container custom-dialog" modal :style="{ width: '30rem' }" :closable="false">
        <div class="header-container">
            <span class="title-dialog">Bloquer un utilisateur</span>
        </div>

        <div class="form-container mt-3">
            <FormKit
                type="form"
                id="blacklistUserFormModal"
                @submit="onSubmitForm"
                :actions="false"
                incomplete-message="Désolé, tous les champs ne sont pas remplis correctement."
                #default="{ state: { valid } }"
            >
                <div class="row mt-5">
                    <div class="col">
                        <label class="form-check-label fw-bold">Etat :</label>
                        <div class="w-100 mb-4"></div>
                        <FormKit type="radio"
                                 name="isBlackListed"
                                 model-value="0"
                                 class="form-check-inline"
                                 :options="formOptions"
                                 help="L'utilisateur sera bloqué et ne pourra plus se connecter à son compte."
                        />
                    </div>
                    <div class="w-100"></div>
                    <div class="col">
                        <label class="form-check-label fw-bold mb-3" for="comment">
                            Commentaire <span style="color:red;">*</span> :
                        </label>
                        <FormKit type="textarea"
                                 name="comment"
                                 class="form-comment"
                                 validation="required|length:1,255|isCommentNotEmpty"
                                 :validation-rules="{ isCommentNotEmpty }"
                                 :validation-messages="{
                                    required: 'Veuillez entrer une description.',
                                    length: 'Ce champ doit contenir maximum 255 caractères.',
                                    isCommentNotEmpty: 'Veuillez entrer une description.',
                            }"
                        />
                    </div>
                </div>

                <div class="footer-container">
                    <FormKit type="button"
                             label="Annuler"
                             @click="closeDialog"
                             class="mr-2 button-cancel"
                             style="background-color: #ff4d4d; color: white;"
                    />
                    <FormKit type="submit" label="Valider" class="button-confirm" :disabled="!valid || isFormSubmitting"/>
                </div>
            </FormKit>
        </div>
    </Dialog>
</template>

<script lang="ts" setup>
import {BlacklistResponseOnPost, blacklistUser} from "@/_services/blackList/blacklist";
import {useAuthStore} from "@/stores/auth/authStore";
import {ref, computed, defineEmits, reactive} from "vue";
import {useRouter} from "vue-router";
const router = useRouter();
import swal from "@/_helpers/swal";
import Dialog from 'primevue/dialog';

const authStore = useAuthStore();
const emit = defineEmits(['confirm', 'update:visible']);
const props = defineProps({
    userUuid: {
        type: String,
        required: true,
    },
    visible: {
        type: Boolean,
        required: true,
        default: false,
    },
});

const isFormSubmitting = ref<boolean>(false);
const BLACKLIST_OPTION_VALUE = "0";
const userUuid = computed(() => props.userUuid);

const formOptions = [
    {
        label: "Blacklister - L'utilisateur sera bloqué et ne pourra plus se connecter à son compte.",
        value: BLACKLIST_OPTION_VALUE
    },
];

const isCommentNotEmpty = (node): boolean => {
    let comment= node.value;
    const regex = new RegExp(/\S/);
    
    return regex.test(comment);
};

const closeDialog = (): void => {
    emit('update:visible', false);
    resetFormData();
};

const formData = reactive({
    comment: '',
});

const resetFormData = (): void => {
    formData.comment = '';
};

const onSubmitForm = async (formData: object, formNode) => {
    isFormSubmitting.value = true;
    const currentUserAdminUuid = authStore.getCurrentUserUuid();
    if (currentUserAdminUuid) {
        await blacklistUser(userUuid.value, true, formData.comment)
            .then((result: BlacklistResponseOnPost | null) => {
                if (result) {
                    router.push({ name: 'UserBlacklistHistorique', params: { uuid: result.blacklistUuid } });
                } else {
                    isFormSubmitting.value = true;
                    swal.error("Le traitement a echoué");
                }
            })
            .catch((error) => {
                isFormSubmitting.value = true;
                console.dir(error);
                swal.error("Le traitement a echoué");
            });
    }
};
</script>

<style scoped lang="scss">
.footer-container {
    display: flex;
    justify-content: end;
    gap: 0.5rem;
}
.title-dialog {
    font-size: 18px;
    text-transform: uppercase;
    color: #0A3382;
    position: relative;
    margin-bottom: 30px;
    &:after {
        content: "";
        background: #f5a22e;
        width: 35px;
        height: 3px;
        position: absolute;
        bottom: -10px;
        left: 0;
        display: block;
    }
}
</style>